<script setup>
import { defineProps } from 'vue';
import { useWindowSize } from '@vueuse/core';
const { width } = useWindowSize();
defineProps({
  text: {
    type: String,
    default: ''
  }
});
</script>
<template>
  <div class="article__tip">
    <div class="article__tip-bubble">
      <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 7.21238e-07L16.5 21.5L7.86805e-07 18L0 7.21238e-07Z" fill="#FAF4EB"/>
      </svg>
      <div>
        <span v-html="text"></span>
      </div>
    </div>
    <img src="@/assets/img/bob3.png" alt="" v-if="width > 768">
    <img src="@/assets/img/bob6.png" alt="" v-else>
  </div>
</template>